
import React, {useEffect,useReducer,useState} from 'react';
import {Link} from "react-router-dom";

import {_printDate, _printMediumDate, _printNumber} from '../../helpers/helpers.js'

import CopyLink from '../../components/copyLink.js'
//import SocialShare from '../../components/socialShare.js'

import {RtCWEInfo, RtCWERecentInfo, RtCWEsPageResult} from '../../../../server/routes/cwe.js'

interface CWEsProps {
    server: string;
    pageData: unknown;
}

function TrimCWEId(descr: string): string {
        // remove CWE-XX
        let cwe=descr.match(/^CWE-\d+\s+(.*)$/gi);   
        if (cwe != null) {
                let space = descr.indexOf(' ');
                return descr.substring(space)
        }
        return descr;
}

export default function CWEs({server, pageData}: CWEsProps) {

	let [data, setData] = useState(pageData as RtCWEsPageResult);

	return (
        <>
             <CWESearch props={data}/>
             <CWEBody props={data}/>
        </>
	)
}


function CWESearch({props}: {props: RtCWEsPageResult}) {
        function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
            event.preventDefault()
            var q = document.getElementById('q') as HTMLInputElement;
            let t=String(q.value).trim();   
       //     console.log(`Search params: ${q.value}`);
            let cwe=t.match(/^CWE-\d{2,4}$/gi);   
       //     console.log(`cwe : ${cwe}`);
            if (cwe != null) {
       //         console.log(`cwe != null: ${cwe[0]}`);
                document.location = '/cwe/'+cwe[0].toUpperCase();
            } else {
                cwe=t.match(/^\d{2,4}$/gi);
                if (cwe != null) {
                        document.location = '/cwe/'+cwe[0];
                    } else {
                        // reject form submission
                    }
                }
          } 
    
        return (
            <section className="section section-sm text-center">
                <div className="container">
                    <div className="text-center">
                        <h2>CWE Lookup</h2>
                        <p>
                            <span style={{maxWidth: '690px'}}>
                                Search Common Weakness Enumerations (CWE) by number.
                            </span>
                        </p>
                    </div>
    
                    <br/>
                    <br/>
                    <div>			
                        <form className="rd-form rd-search form-inline" action="search" method="GET"  onSubmit={handleSubmit}>
                            <div className="form-wrap">
                                <input required type="text" className="form-input" title="Lookup CWE by number" placeholder="Lookup CWE (for example 89 or CWE-89)" name="q" id="q"/>
                            </div>
                            <div className="form-wrap form-button">
                                <button className="button button-secondary button-shadow" type="submit" >Search</button>
                            </div>
                        </form>
                    </div>            
                </div>
            </section>
        )
    }
    
    function CWEBody({props}: {props: RtCWEsPageResult}) {
	return (
        <>
                <section className="section section-sm">
                        <div className="container">
                                <div className="row row-50">
                                        <div className="col-md-12 col-lg-12 col-xl-12">
  {/* The potential vulnerabilities are identified by detecting the presence of vulnerable plugins and software libraries within the website’s codebase.' */}
                                                <CWEList 
                                                        link={props.CanonicalURL!}
                                                        anchor='top25'
                                                        title='MITRE 2024 Top 25 CWEs' 
                                                        subtitle='List of top most critical software weaknesses. Only Common Weakness Enumerations (CWEs) that are detectable from client-side software packages and libraries are included.'
                                                        list={props.Top25CWEs} />         
                                        </div>	                                        
                                        <div className="col-md-12 col-lg-12 col-xl-12">
                                                <CWEListUpdated                                                
                                                        link={props.CanonicalURL!}
                                                        anchor='recent'
                                                        title='Most recently updated CWEs' 
                                                        subtitle='CWE with mostly recently updated or discovered CVE vulnerabilities. Only Common Weakness Enumerations (CWEs) that are detectable from client-side software packages and libraries are included.'
                                                        list={props.MostRecentCWEs}/>
                                        </div>
                                        <div className="col-md-12 col-lg-12 col-xl-12">
                                                <CWEList 
                                                        link={props.CanonicalURL!}
                                                        anchor='common'
                                                        title='Most prevalent CWEs' 
                                                        subtitle='The list of most widespread CWEs. Only Common Weakness Enumerations (CWEs) that are detectable from client-side software packages and libraries are included.'
                                                        list={props.BiggestDomainCountCWEs} />
                                        </div>						
                                </div>
                        </div>
                </section>
        </>
	)
};


interface CWEListProps {
    link: string;
    anchor: string;
    title: string;
    subtitle: string;
    list: RtCWEInfo[];
}

function CWEList({link,anchor,title, subtitle, list}: CWEListProps) {
        // uncomment to make it sharable
        // link = 'https://webtechsurvey.com/technology/recurly';
return (
<>
        <h4 id={anchor}>{title}
        <CopyLink link={link}  anchor={anchor}/> 
        </h4>  
        {' '}{subtitle}  
        <br/>    
        <div className="table-outer table-rounded table-responsive-lg">
        <table className="table-custom table-custom-striped table-custom-primary  ">
                <thead>
                <tr>
                        <th style={{width: '15%'}}>CWE</th> 
                        <th style={{width: '70%'}}>Description</th> 
                        <th style={{width: '15%'}}>Websites</th>
                </tr>
                </thead>
                        <tbody>
                                {
                                list.map((cwe, indexKey) => {
                                        if (cwe.DomainCount) {
                                                return (<CWERow cwe={cwe} key={indexKey}/>);
                                        } else {
                                                return (<></>);
                                      //          return (<CWERowNoLink cwe={cwe} key={indexKey}/>);
                                        }
                                })
                        }	
                </tbody>
        </table>
        </div>
        
</>
)
}

interface CWEListUpdatedProps {
    link: string;
    anchor: string;
    title: string;
    subtitle: string;
    list: RtCWERecentInfo[];
}

function CWEListUpdated({link,anchor,title, subtitle, list}: CWEListUpdatedProps) {
return (
<>
        <h4 id={anchor}>{title}
        <CopyLink link={link} anchor={anchor} /> 
        </h4>   
        
        {subtitle} 
        <br/>    
        <div className="table-outer table-rounded table-responsive-lg">
        <table className="table-custom table-custom-striped table-custom-primary  ">
                <thead>
                <tr>
                        <th style={{width: '15%'}}>CWE</th> 
                        <th style={{width: '70%'}}>Description</th> 
                        <th style={{width: '15%'}}>Updated</th> 
                 </tr>
                </thead>
                        <tbody>
                                {
                                list.map((cwe, indexKey) => {
                                        return (
                                                <CWERowUpdated cwe={cwe} key={indexKey}/>
                                        )
                                })
                        }	
                </tbody>
        </table>
        </div>
        
</>
)
}
                        
/*
function CVERow({cve, requireAuthentication}) {
        let techInfo = cve.CVETechnologyInfo;
        // icon, tech, version, category, date, count
        return (
        <>
        <tr>									
                        <TechnologySmallIcon 
                                technologyIcon={techInfo.Icon} 
                                technology={techInfo.ShortName}
                        />
                        <b>
                        {' '}{techInfo.ShortName}
                        </b> 
                <td>
                        <Link 
                                to={`/technology/${techInfo.URL}/versions`} 
                                className="link-hover" 
                                title={`Show all versions of ${techInfo.ShortName}`}
                        >
                                {techInfo.Version}
                        </Link>                
                </td>
                <td>
                        {_printNumber(cve.DomainCount)}
                </td>
        </tr>		
        </>
)
}

*/


interface CWERowProps {
    cwe: RtCWEInfo;
    requireAuthentication?: boolean;
}

function CWERow({cwe, requireAuthentication}: CWERowProps) {
// CWEID, Description, count
return (
        <>     
        <tr>
                <td>	                     
                        <Link 
                                to={`/cwe/${cwe.CWEId}`} 
                                className="link-hover" 
                        >
                                <b>{cwe.CWEId}</b>
                        </Link> 							
                </td>
                <td>	                     
                        {TrimCWEId(cwe.Title)}				
                </td>
                <td>                        
                        <Link 
                                to={`/cwe/${cwe.CWEId}/websites`} 
                                className="link-hover" 
                                title={`List of websites affected by ${cwe.CWEId}`} 
                        >
                        <b>{_printNumber(cwe.DomainCount)}</b>
                        </Link> 
                </td>
        </tr>		
        </>
)
}

interface CWERowNoLinkProps {
    cwe: RtCWEInfo;
    requireAuthentication?: boolean;
}

function CWERowNoLink({cwe, requireAuthentication}: CWERowNoLinkProps) {
// CWEID, Description, count
return (
        <>     
        <tr>
                <td>	                     
                        {cwe.CWEId}							
                </td>
                <td>	                     
                       {TrimCWEId(cwe.Title)}					
                </td>
                <td>                       
                       {_printNumber(cwe.DomainCount)}
                </td>
        </tr>		
        </>
)
}
        
interface CWERowUpdatedProps {
    cwe: RtCWERecentInfo;
    requireAuthentication?: boolean;
}

function CWERowUpdated({cwe, requireAuthentication}: CWERowUpdatedProps) {
// CWEID, Description, count
return (
        <>     
        <tr>
                <td>	                     
                        <Link 
                                to={`/cwe/${cwe.CWEId}`} 
                                className="link-hover" 
                        >
                               <b>{cwe.CWEId}</b>
                        </Link> 							
                </td>
                <td>	                     
                        {TrimCWEId(cwe.Title)}							
                </td>
                <td>
                        {_printMediumDate(cwe.MostRecentCVE)}
                </td>
        </tr>		
        </>
)
}
        